import {
  CLIENT,
  CLIENT_CLEAR_DATA,
  CLIENT_ERROR,
  CLIENT_ONE,
  CLIENT_ONE_BY_PROJECT,
  CLIENT_ONE_BY_PROJECT_SUCCESS,
  CLIENT_ONE_CLEAR_DATA,
  CLIENT_ONE_ERROR,
  CLIENT_ONE_SUCCESS,
  CLIENT_SUCCESS,
} from "./actionTypes";

export const client = (client, history) => {
  return {
    type: CLIENT,
    payload: { client, history },
  };
};

export const clientSuccess = (success) => {
  return {
    type: CLIENT_SUCCESS,
    payload: { ...success },
  };
};

export const clientError = (error) => {
  return {
    type: CLIENT_ERROR,
    payload: error,
  };
};

export const clientClearData = () => {
  return {
    type: CLIENT_CLEAR_DATA,
    payload: {},
  };
};

export const clientOne = (client) => {
  return {
    type: CLIENT_ONE,
    payload: { client },
  };
};

export const clientOneSuccess = (success) => {
  return {
    type: CLIENT_ONE_SUCCESS,
    payload: success,
  };
};
export const clientOneError = (error) => {
  return {
    type: CLIENT_ONE_ERROR,
    payload: error,
  };
};

export const clientOneClearData = () => {
  return {
    type: CLIENT_ONE_CLEAR_DATA,
    payload: {},
  };
};

export const clientOneByProject = (client, history) => {
  return {
    type: CLIENT_ONE_BY_PROJECT,
    payload: { client, history },
  };
};

export const clientOneByProjectSuccess = (success) => {
  return {
    type: CLIENT_ONE_BY_PROJECT_SUCCESS,
    payload: { ...success },
  };
};
